<template>
  <div>
    <div class="toolbar">
      <div>
        <h2>大分类管理</h2>
        <p class="hint">最多 {{ maxCount }} 个（键盘 4×4），当前 {{ list.length }} 个</p>
      </div>
      <el-button type="primary" :disabled="atLimit" @click="openForm()">新增</el-button>
    </div>
    <div class="filters">
      <el-input
        v-model="keyword"
        placeholder="搜索名称（中/缅）"
        clearable
        prefix-icon="el-icon-search"
        class="filter-input"
      />
      <el-select v-model="filterCityId" placeholder="城市" class="filter-select" @change="load">
        <el-option label="全部" value="all" />
        <el-option label="待分配" :value="0" />
        <el-option v-for="c in cities" :key="c.id" :label="c.name_zh" :value="c.id" />
      </el-select>
      <el-radio-group v-model="sortAsc" size="small">
        <el-radio-button :label="true">正序</el-radio-button>
        <el-radio-button :label="false">倒序</el-radio-button>
      </el-radio-group>
    </div>
    <div v-if="!isMobile" class="table-scroll">
    <el-table :data="displayList" v-loading="loading" border>
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column label="城市" width="100">
        <template slot-scope="{ row }">
          <span v-if="row.city_name_zh">{{ row.city_name_zh }}</span>
          <el-tag v-else type="warning" size="mini">待分配</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="name_zh" label="中文名" />
      <el-table-column prop="name_my" label="缅文名" />
      <el-table-column prop="sort_order" label="排序" width="80" />
      <el-table-column label="展示" width="80">
        <template slot-scope="{ row }">
          <el-tag :type="row.is_active ? 'success' : 'info'" size="mini">
            {{ row.is_active ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openForm(row)">编辑</el-button>
          <el-button type="text" style="color:#f56c6c" @click="onDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <MobileCardList
      v-if="isMobile"
      :data="displayList"
      :loading="loading"
      :fields="cardFields"
    >
      <template #is_active="{ row }">
        <el-tag :type="row.is_active ? 'success' : 'info'" size="mini">
          {{ row.is_active ? '是' : '否' }}
        </el-tag>
      </template>
      <template #actions="{ row }">
        <el-button type="text" @click="openForm(row)">编辑</el-button>
        <el-button type="text" style="color:#f56c6c" @click="onDelete(row)">删除</el-button>
      </template>
    </MobileCardList>

    <el-dialog :title="form.id ? '编辑大分类' : '新增大分类'" :visible.sync="visible" width="480px">
      <el-form :model="form" label-width="90px">
        <el-form-item label="城市">
          <el-select v-model="form.city_id" clearable placeholder="留空=待分配" style="width:100%">
            <el-option v-for="c in cities" :key="c.id" :label="c.name_zh" :value="c.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="中文名"><el-input v-model="form.name_zh" /></el-form-item>
        <el-form-item label="缅文名"><el-input v-model="form.name_my" /></el-form-item>
        <el-form-item label="排序"><el-input-number v-model="form.sort_order" :min="1" /></el-form-item>
        <el-form-item label="展示"><el-switch v-model="form.is_active" :active-value="1" :inactive-value="0" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="onSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { api } from '../api';
import { calcNextSortOrder, filterByKeyword, sortByOrder, MAX_MAIN_CATEGORY_KEYBOARD } from '../utils/listHelpers';
import responsiveMixin from '../mixins/responsive';

const emptyForm = () => ({
  id: null, city_id: null, name_zh: '', name_my: '', sort_order: 1, is_active: 1,
});

export default {
  name: 'MainCategory',
  mixins: [responsiveMixin],
  data() {
    return {
      list: [],
      cities: [],
      loading: false,
      visible: false,
      form: emptyForm(),
      keyword: '',
      filterCityId: 'all',
      sortAsc: true,
      cardFields: [
        { label: 'ID', prop: 'id' },
        { label: '城市', prop: 'city_name_zh' },
        { label: '中文名', prop: 'name_zh' },
        { label: '缅文名', prop: 'name_my' },
        { label: '排序', prop: 'sort_order' },
        { label: '展示', prop: 'is_active' },
      ],
    };
  },
  computed: {
    maxCount() {
      return MAX_MAIN_CATEGORY_KEYBOARD;
    },
    atLimit() {
      return this.list.length >= MAX_MAIN_CATEGORY_KEYBOARD;
    },
    displayList() {
      return sortByOrder(filterByKeyword(this.list, this.keyword), this.sortAsc);
    },
  },
  created() {
    this.loadCities();
    this.load();
  },
  methods: {
    async loadCities() {
      try {
        const { data } = await api.cities.list();
        this.cities = data;
      } catch (e) {
        this.$message.error(e.message);
      }
    },
    async load() {
      this.loading = true;
      try {
        const params = {};
        if (this.filterCityId === 0) params.city_id = 0;
        else if (this.filterCityId !== 'all') params.city_id = this.filterCityId;
        const { data } = await api.mainCategories.list(params);
        this.list = data;
      } catch (e) {
        this.$message.error(e.message);
      } finally {
        this.loading = false;
      }
    },
    openForm(row) {
      if (!row && this.atLimit) {
        this.$message.warning(`大分类最多 ${MAX_MAIN_CATEGORY_KEYBOARD} 个`);
        return;
      }
      if (row) {
        this.form = { ...row };
      } else {
        this.form = {
          ...emptyForm(),
          city_id: this.filterCityId !== 'all' && this.filterCityId !== 0 ? this.filterCityId : null,
          sort_order: calcNextSortOrder(this.list),
        };
      }
      this.visible = true;
    },
    onSubmit() {
      const action = this.form.id ? '保存修改' : '新增';
      this.$confirm(`确认${action}该大分类？`, '提示', { type: 'warning' })
        .then(async () => {
          try {
            if (this.form.id) {
              await api.mainCategories.update(this.form.id, this.form);
            } else {
              await api.mainCategories.create(this.form);
            }
            this.$message.success('操作成功');
            this.visible = false;
            this.load();
          } catch (e) {
            this.$message.error(e.message);
          }
        })
        .catch(() => {});
    },
    onDelete(row) {
      this.$confirm(`确认删除大分类「${row.name_zh}」？（逻辑删除，小分类将变为待分配）`, '删除确认', {
        type: 'warning',
        confirmButtonText: '确认删除',
        confirmButtonClass: 'el-button--danger',
      })
        .then(async () => {
          try {
            await api.mainCategories.remove(row.id);
            this.$message.success('已删除');
            this.load();
          } catch (e) {
            this.$message.error(e.message);
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.toolbar { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
.toolbar h2 { margin: 0; }
.hint { margin: 4px 0 0; font-size: 13px; color: #909399; }
.filters { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; flex-wrap: wrap; }
.filter-input { width: 220px; }
.filter-select { width: 160px; }
</style>
